module.exports = new __parcel__URL__("righteousprayer.0564ee71.png").toString();